export interface ConversationDetails {
    adminCount: number;
    config: Config;
    conversationImageUrl: string | null;
    conversationTitle: string | null;
    conversationType: number;
    createdAt: number;
    createdBy: string;
    createdByUserImageUrl: string;
    createdByUserName: string;
    customType: string;
    hiddenForCreator: boolean;
    isGroup: boolean;
    lastMessageSentAt: number;
    lastReadAt: LastReadAt;
    membersCount: number;
    metaData: MetaData;
    opponentDetails: OpponentDetails;
    privateOneToOne: boolean;
    searchableTags: string[];
    updatedAt: number;
    usersOwnDetails: UsersOwnDetails;
    groupcastImageUrl: string | null;
    groupcastTitle: string | null;
    groupcastId: string;
  }
  
  interface Config {
    typingEvents: boolean;
    readEvents: boolean;
    pushNotifications: boolean;
  }
  
  interface LastReadAt {
    [key: string]: number; // keys are user IDs, values are timestamps
  }
  
  interface MetaData {
    [key: string]: any;
  }
  
  interface OpponentDetails {
    userProfileImageUrl: string;
    userName: string;
    userIdentifier: string;
    userId: string;
    online: boolean;
    [key: string]: any;
  }
  
  interface UsersOwnDetails {
    memberId: string;
    lastMessageSentAt: number;
    isDeleted: boolean;
    isAdmin: boolean;
  }
  